import { ReactComponent as Lightbulb } from '../../../assets/icons/lightbulb.svg';
import { ReactComponent as Card } from '../../../assets/icons/card.svg';
import { ReactComponent as Truck } from '../../../assets/icons/truck.svg';
import { ReactComponent as VerifiedOutline } from '../../../assets/icons/verified-outline.svg';
import { ReactComponent as RegisterArrows } from '../../../assets/icons/register-arrows.svg';

const qAndA = {
  howItWorks: {
    tabTitleIntl: 'HelpCenter.Tabs.HowItWorks',
    icon: <Lightbulb />,
    questionsAndAnswers: [
      {
        id: 'how-it-works-1',
        question: 'HelpCenter.HowItWorks.q1',
        answer: 'HelpCenter.HowItWorks.a1',
      },
      {
        id: 'how-it-works-2',
        question: 'HelpCenter.HowItWorks.q2',
        answer: 'HelpCenter.HowItWorks.a2',
      },
      {
        id: 'how-it-works-3',
        question: 'HelpCenter.HowItWorks.q3',
        answer: 'HelpCenter.HowItWorks.a3',
      },
      {
        id: 'how-it-works-4',
        question: 'HelpCenter.HowItWorks.q4',
        answer: 'HelpCenter.HowItWorks.a4',
      },
      {
        id: 'how-it-works-5',
        question: 'HelpCenter.HowItWorks.q5',
        answer: 'HelpCenter.HowItWorks.a5',
      },
      {
        id: 'how-it-works-6',
        question: 'HelpCenter.HowItWorks.q6',
        answer: 'HelpCenter.HowItWorks.a6',
      },
    ],
  },

  buyAndSell: {
    tabTitleIntl: 'HelpCenter.Tabs.BuyAndSell',
    icon: <Card />,
    questionsAndAnswers: [
      {
        id: 'buy-sell-1',
        question: 'HelpCenter.BuyAndSell.q1',
        answer: 'HelpCenter.BuyAndSell.a1',
      },
      {
        id: 'buy-sell-2',
        question: 'HelpCenter.BuyAndSell.q2',
        answer: 'HelpCenter.BuyAndSell.a2',
      },
      {
        id: 'buy-sell-3',
        question: 'HelpCenter.BuyAndSell.q3',
        answer: 'HelpCenter.BuyAndSell.a3',
      },
      {
        id: 'buy-sell-4',
        question: 'HelpCenter.BuyAndSell.q4',
        answer: 'HelpCenter.BuyAndSell.a4',
      },
      {
        id: 'buy-sell-5',
        question: 'HelpCenter.BuyAndSell.q5',
        answer: 'HelpCenter.BuyAndSell.a5',
      },
      {
        id: 'buy-sell-6',
        question: 'HelpCenter.BuyAndSell.q6',
        answer: 'HelpCenter.BuyAndSell.a6',
      },
      {
        id: 'buy-sell-7',
        question: 'HelpCenter.BuyAndSell.q7',
        answer: 'HelpCenter.BuyAndSell.a7',
      },
    ],
  },

  shippingAndReturns: {
    tabTitleIntl: 'HelpCenter.Tabs.ShippingAndReturns',
    icon: <Truck />,
    questionsAndAnswers: [
      {
        id: 'shipping-methods',
        question: 'HelpCenter.ShippingAndReturns.q1',
        answer: 'HelpCenter.ShippingAndReturns.a1',
      },
      {
        id: 'shipping-responsibility',
        question: 'HelpCenter.ShippingAndReturns.q2',
        answer: 'HelpCenter.ShippingAndReturns.a2',
      },
      {
        id: 'returns-refunds',
        question: 'HelpCenter.ShippingAndReturns.q3',
        answer: 'HelpCenter.ShippingAndReturns.a3',
      },
      {
        id: 'tracking-updates',
        question: 'HelpCenter.ShippingAndReturns.q4',
        answer: 'HelpCenter.ShippingAndReturns.a4',
      },
      {
        id: 'buyer-protection',
        question: 'HelpCenter.ShippingAndReturns.q5',
        answer: 'HelpCenter.ShippingAndReturns.a5',
      },
      {
        id: 'shipping-process',
        question: 'HelpCenter.ShippingAndReturns.q6',
        answer: 'HelpCenter.ShippingAndReturns.a6',
      },
      {
        id: 'packaging-shirt',
        question: 'HelpCenter.ShippingAndReturns.q7',
        answer: 'HelpCenter.ShippingAndReturns.a7',
      },
      {
        id: 'return-shirt',
        question: 'HelpCenter.ShippingAndReturns.q8',
        answer: 'HelpCenter.ShippingAndReturns.a8',
      },
    ],
  },

  verificationAndSecurity: {
    tabTitleIntl: 'HelpCenter.Tabs.VerificationAndSecurity',
    icon: <VerifiedOutline />,
    questionsAndAnswers: [
      {
        id: 'verification-1',
        question: 'HelpCenter.VerificationAndSecurity.q1',
        answer: 'HelpCenter.VerificationAndSecurity.a1',
      },
      {
        id: 'verification-2',
        question: 'HelpCenter.VerificationAndSecurity.q2',
        answer: 'HelpCenter.VerificationAndSecurity.a2',
      },
      {
        id: 'verification-3',
        question: 'HelpCenter.VerificationAndSecurity.q3',
        answer: 'HelpCenter.VerificationAndSecurity.a3',
      },
    ],
  },

  registrationAndLogin: {
    tabTitleIntl: 'HelpCenter.Tabs.RegistrationAndLogin',
    icon: <RegisterArrows />,
    questionsAndAnswers: [
      {
        id: 'registration-1',
        question: 'HelpCenter.RegistrationAndLogin.q1',
        answer: 'HelpCenter.RegistrationAndLogin.a1',
      },
      {
        id: 'registration-2',
        question: 'HelpCenter.RegistrationAndLogin.q2',
        answer: 'HelpCenter.RegistrationAndLogin.a2',
      },
      {
        id: 'registration-3',
        question: 'HelpCenter.RegistrationAndLogin.q3',
        answer: 'HelpCenter.RegistrationAndLogin.a3',
        hasContact: true,
      },
      {
        id: 'registration-4',
        question: 'HelpCenter.RegistrationAndLogin.q4',
        answer: 'HelpCenter.RegistrationAndLogin.a4',
        hasContact: true,
      },
    ],
  },
};

export default qAndA;